<template>BOT DATA EDITOR</template>
